import { BenefitsListPage, BenefitsListPageType } from '@/@types/benefitsListPage';

export type CreditHistoryPriority = 'PRIORITY_CONTACT_BUY' | 'PRIORITY_CONTACT_RENT';

export const getCreditHistoryPathSegment = (benefitsListPage: BenefitsListPage) => {
  return benefitsListPage === BenefitsListPage.KauferPlus
    ? BenefitsListPageType.KauferPlus
    : BenefitsListPageType.MieterPlus;
};

export const getCreditHistoryPriority = (pathSegment?: string): CreditHistoryPriority => {
  return pathSegment === BenefitsListPageType.KauferPlus ? 'PRIORITY_CONTACT_BUY' : 'PRIORITY_CONTACT_RENT';
};
